export default class Screenshot {
  constructor () {
    this.username = null
    this.url = null
    this.createdAt = null
    this.page = null
    this.rid = null
  }

  static fromJson (json) {
    let screenshot = new this()
    if (json.username !== null) {
      screenshot.username = json.username
    }
    if (json.url !== null) {
      screenshot.url = json.url
    }
    if (json.created_at !== null) {
      screenshot.createdAt = Date.parse(json.created_at)
    }
    if (json.page !== null) {
      screenshot.page = json.page
    }
    if (json.rid !== null) {
      screenshot.rid = json.rid
    }
    return screenshot
  }
}



// WEBPACK FOOTER //
// ./src/models/screenshot.js